import { c as _c } from "react/compiler-runtime";
import React from 'react';
const CityStateSuggestionsDropdown = t0 => {
  const $ = _c(19);
  const {
    listboxId,
    dropdownPosition,
    suggestions,
    activeIndex,
    onSelectSuggestion,
    onHoverSuggestion
  } = t0;
  let t1;
  if ($[0] !== dropdownPosition.left || $[1] !== dropdownPosition.top || $[2] !== dropdownPosition.width) {
    t1 = {
      top: dropdownPosition.top,
      left: dropdownPosition.left,
      width: dropdownPosition.width
    };
    $[0] = dropdownPosition.left;
    $[1] = dropdownPosition.top;
    $[2] = dropdownPosition.width;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== activeIndex || $[5] !== listboxId || $[6] !== onHoverSuggestion || $[7] !== onSelectSuggestion || $[8] !== suggestions) {
    let t3;
    if ($[10] !== activeIndex || $[11] !== listboxId || $[12] !== onHoverSuggestion || $[13] !== onSelectSuggestion) {
      t3 = (suggestion, index) => {
        const {
          placePrediction
        } = suggestion;
        if (!placePrediction) {
          return null;
        }
        const isActive = index === activeIndex;
        return <li key={placePrediction.placeId || index} id={`${listboxId}-option-${index}`} role="option" aria-selected={isActive} className={`px-3 py-2 cursor-pointer text-base text-gray-dark ${isActive ? "bg-gray-light6" : ""}`} onMouseDown={_temp} onClick={() => {
          onSelectSuggestion(index);
        }} onMouseEnter={() => onHoverSuggestion(index)}>{(placePrediction.text?.toString() || "").replace(/, USA$/, "")}</li>;
      };
      $[10] = activeIndex;
      $[11] = listboxId;
      $[12] = onHoverSuggestion;
      $[13] = onSelectSuggestion;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    t2 = suggestions.map(t3);
    $[4] = activeIndex;
    $[5] = listboxId;
    $[6] = onHoverSuggestion;
    $[7] = onSelectSuggestion;
    $[8] = suggestions;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[15] !== listboxId || $[16] !== t1 || $[17] !== t2) {
    t3 = <ul id={listboxId} role="listbox" className="fixed z-50 bg-white border border-gray-light3 shadow-lg max-h-64 overflow-auto" style={t1}>{t2}</ul>;
    $[15] = listboxId;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  return t3;
};
export default CityStateSuggestionsDropdown;
function _temp(event) {
  event.preventDefault();
}